import { Link } from '@design-system/link';
import { Section } from '@design-system/section';
import React, { FC } from 'react';

import { SkipLinkProps } from '../../models';

export const SkipLink: FC<SkipLinkProps> = ({
  children,
  mode,
  ...linkProps
}) => (
  <Section element="div" mode={mode} className="cds-skip-link">
    <Link className="cds-skip-link__link" {...linkProps}>
      {children}
    </Link>
  </Section>
);
